/**
 * Utility function to check approval status and determine visibility
 * @param {string} status - The current approval status
 * @param {Function} checkPermission - Function to check user permissions
 * @param {Function} setVisibility - Function to set approval visibility state
 */
export const checkStatusApproval = (status, checkPermission, setVisibility) => {
  if (status === 'Menunggu Approval' && checkPermission('send for approval')) {
    setVisibility(false);
  } else if (status === 'Menunggu Approval' && checkPermission('approve realisasi kpi korporat')) {
    setVisibility(true);
  } else if (status === 'Approved') {
    setVisibility(false);
  } else {
    setVisibility(true);
  }
};
